var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-dark",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 142.896,
    height: 57.551,
    viewBox: "0 0 142.896 57.551",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_120",
    "data-name": "Rectangle 120",
    width: 142.896,
    height: 57.551,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M286.668,56.886c0,2.5-1.963,3.966-5.72,3.966h-7.265V46.239h6.847c3.507,0,5.386,1.482,5.386,3.8a3.5,3.5,0,0,1-1.879,3.215,3.6,3.6,0,0,1,2.63,3.633M276.4,48.368V52.4h3.841c1.879,0,2.943-.668,2.943-2,0-1.357-1.065-2.025-2.943-2.025Zm7.536,8.246c0-1.461-1.107-2.108-3.152-2.108H276.4v4.217h4.384c2.046,0,3.152-.647,3.152-2.109",
    transform: "translate(-207.794 -35.107)",
    fill: "#024064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M351.341,51.7v6.388h-2.61V52.033c0-1.984-.981-2.944-2.651-2.944-1.858,0-3.11,1.127-3.11,3.361v5.637h-2.61V42.6h2.61v5.636a4.97,4.97,0,0,1,3.716-1.419c2.672,0,4.656,1.524,4.656,4.885",
    transform: "translate(-258.419 -32.342)",
    fill: "#024064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M408.32,64.851v6.534h-2.463V70.028a3.951,3.951,0,0,1-3.507,1.5c-2.547,0-4.154-1.4-4.154-3.34,0-1.858,1.253-3.319,4.635-3.319h2.881V64.7c0-1.524-.919-2.422-2.777-2.422a5.521,5.521,0,0,0-3.382,1.106l-1.023-1.9a7.84,7.84,0,0,1,4.718-1.378c3.215,0,5.073,1.524,5.073,4.739M405.711,67.9V66.6h-2.693c-1.775,0-2.255.668-2.255,1.482,0,.94.794,1.545,2.129,1.545a2.842,2.842,0,0,0,2.818-1.732",
    transform: "translate(-302.33 -45.64)",
    fill: "#024064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M462.306,60.112V62.6a3.324,3.324,0,0,0-.606-.063c-1.983,0-3.236,1.169-3.236,3.444v5.407h-2.61V60.237h2.484v1.629a4.387,4.387,0,0,1,3.967-1.754",
    transform: "translate(-346.109 -45.64)",
    fill: "#024064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M500.144,64.851v6.534h-2.463V70.028a3.951,3.951,0,0,1-3.508,1.5c-2.547,0-4.154-1.4-4.154-3.34,0-1.858,1.253-3.319,4.635-3.319h2.881V64.7c0-1.524-.919-2.422-2.776-2.422a5.522,5.522,0,0,0-3.382,1.106l-1.023-1.9a7.84,7.84,0,0,1,4.718-1.378c3.215,0,5.073,1.524,5.073,4.739M497.535,67.9V66.6h-2.693c-1.775,0-2.255.668-2.255,1.482,0,.94.793,1.545,2.129,1.545a2.841,2.841,0,0,0,2.818-1.732",
    transform: "translate(-372.048 -45.64)",
    fill: "#024064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M549.707,63.407a4.1,4.1,0,0,1-2.505.752c-2.443,0-3.841-1.294-3.841-3.758V55.036h-1.837V52.948h1.837V50.4h2.61v2.547h2.985v2.088H545.97v5.3c0,1.086.543,1.67,1.545,1.67a2.345,2.345,0,0,0,1.461-.459Z",
    transform: "translate(-411.153 -38.267)",
    fill: "#024064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M269.346,131.114c0-4.363,3.34-7.515,7.829-7.515a7.4,7.4,0,0,1,5.783,2.442l-1.754,1.649a5.132,5.132,0,0,0-3.9-1.712,5.136,5.136,0,1,0,0,10.272,5.081,5.081,0,0,0,3.9-1.733l1.754,1.67a7.906,7.906,0,0,1-13.612-5.073",
    transform: "translate(-204.502 -93.843)",
    fill: "#024064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M343.81,143.079v6.534h-2.463v-1.357a3.951,3.951,0,0,1-3.507,1.5c-2.547,0-4.154-1.4-4.154-3.34,0-1.858,1.252-3.319,4.635-3.319H341.2v-.167c0-1.524-.919-2.422-2.777-2.422a5.521,5.521,0,0,0-3.382,1.106l-1.023-1.9a7.84,7.84,0,0,1,4.718-1.378c3.215,0,5.073,1.524,5.073,4.739m-2.609,3.048v-1.294h-2.693c-1.775,0-2.255.668-2.255,1.482,0,.94.793,1.545,2.129,1.545a2.842,2.842,0,0,0,2.818-1.732",
    transform: "translate(-253.351 -105.035)",
    fill: "#024064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M397.8,138.34v2.484a3.325,3.325,0,0,0-.605-.063c-1.983,0-3.236,1.169-3.236,3.444v5.407h-2.61V138.465h2.484v1.629a4.387,4.387,0,0,1,3.967-1.754",
    transform: "translate(-297.13 -105.035)",
    fill: "#024064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M440.9,130.741a5.43,5.43,0,0,1-5.658,5.72,4.6,4.6,0,0,1-3.7-1.587v1.44h-2.484v-15.49h2.61v5.7a4.634,4.634,0,0,1,3.57-1.482,5.414,5.414,0,0,1,5.658,5.7m-2.651,0a3.313,3.313,0,1,0-3.3,3.487,3.242,3.242,0,0,0,3.3-3.487",
    transform: "translate(-325.768 -91.737)",
    fill: "#024064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M558.922,143.225v6.388h-2.609v-6.054c0-1.984-.981-2.944-2.651-2.944-1.858,0-3.111,1.127-3.111,3.361v5.637h-2.609V138.465h2.484v1.441a4.847,4.847,0,0,1,3.841-1.566c2.672,0,4.655,1.524,4.655,4.885",
    transform: "translate(-416.025 -105.035)",
    fill: "#024064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M492.01,138.738a6.928,6.928,0,0,0-1.409.147,2.222,2.222,0,0,1,.938,1.8,1.874,1.874,0,0,1-.031.3,3.732,3.732,0,0,1,.5-.037,3.492,3.492,0,1,1-3.3,3.486,3.919,3.919,0,0,1,.355-1.679,2.238,2.238,0,0,1-1.8-1.871,6.069,6.069,0,1,0,4.742-2.149",
    transform: "translate(-369.058 -105.337)",
    fill: "#024064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M497.071,141.639a1.464,1.464,0,1,1-1.409-1.5,1.51,1.51,0,0,1,1.409,1.5",
    transform: "translate(-375.179 -106.401)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M501.871,153.82v2.049a.364.364,0,0,0,.182.315l1.775,1.025a.363.363,0,0,0,.364,0l1.775-1.025a.364.364,0,0,0,.182-.315V153.82a.363.363,0,0,0-.182-.315l-1.775-1.025a.365.365,0,0,0-.364,0l-1.775,1.025a.363.363,0,0,0-.182.315",
    transform: "translate(-381.047 -115.735)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M134.225,204.886a3.172,3.172,0,0,1,.051-6.343,3.172,3.172,0,1,1-.051,6.343",
    transform: "translate(-99.561 -150.744)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M88,201.6a3.173,3.173,0,0,1-3.16,3.2,3.181,3.181,0,0,1-.03-6.361A3.163,3.163,0,0,1,88,201.6",
    transform: "translate(-62.02 -150.665)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M180.312,42.321a3.162,3.162,0,0,1-6.323.1,3.162,3.162,0,1,1,6.323-.1",
    transform: "translate(-132.101 -29.746)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M176.917,180.27a3.145,3.145,0,0,1-3.114-3.233,3.157,3.157,0,0,1,6.313.1,3.127,3.127,0,0,1-3.2,3.137",
    transform: "translate(-131.96 -132.068)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M39.1,176.8a3.109,3.109,0,0,1,3.325-3,3.153,3.153,0,0,1-.306,6.3,3.108,3.108,0,0,1-3.019-3.3",
    transform: "translate(-29.685 -131.961)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M204.832,134.424a3.183,3.183,0,1,1-3.256-3.106,3.209,3.209,0,0,1,3.256,3.106",
    transform: "translate(-150.686 -99.703)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M137.638,17.7a3.158,3.158,0,1,1-3.129-3.21,3.142,3.142,0,0,1,3.129,3.21",
    transform: "translate(-99.707 -10.999)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M42.49,39.062a3.15,3.15,0,0,1-.08,6.3,3.15,3.15,0,1,1,.08-6.3",
    transform: "translate(-29.814 -29.657)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M204.951,85.082a3.2,3.2,0,0,1-3.225,3.116,3.156,3.156,0,0,1-3.115-3.217,3.17,3.17,0,1,1,6.34.1",
    transform: "translate(-150.795 -62.145)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M85.151,14.425a3.159,3.159,0,0,1,3.118,3.229,3.173,3.173,0,0,1-6.345-.112,3.152,3.152,0,0,1,3.227-3.117",
    transform: "translate(-62.201 -10.951)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M17.6,131.066a3.148,3.148,0,0,1,3.142,3.208A3.172,3.172,0,1,1,14.4,134.1a3.147,3.147,0,0,1,3.2-3.036",
    transform: "translate(-10.936 -99.512)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M17.611,87.984a3.134,3.134,0,0,1-3.122-3.214,3.166,3.166,0,1,1,3.122,3.214",
    transform: "translate(-11 -62.01)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M168.074,205.066a2.689,2.689,0,0,1-2.772,2.593,2.685,2.685,0,1,1,2.772-2.593",
    transform: "translate(-123.553 -153.589)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M73.294,48.144a2.679,2.679,0,1,1,2.664-2.713,2.653,2.653,0,0,1-2.664,2.713",
    transform: "translate(-53.626 -32.486)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M179.391,73.2a2.681,2.681,0,0,1-5.362,0,2.681,2.681,0,0,1,5.362,0",
    transform: "translate(-132.132 -53.539)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M151.693,176.649a2.668,2.668,0,0,1-5.335.053,2.7,2.7,0,0,1,2.647-2.743,2.66,2.66,0,0,1,2.688,2.69",
    transform: "translate(-111.122 -132.078)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M73.261,173.985a2.683,2.683,0,1,1-2.651,2.725,2.661,2.661,0,0,1,2.651-2.725",
    transform: "translate(-53.611 -132.098)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M59.568,205.044a2.671,2.671,0,1,1-2.644-2.732,2.655,2.655,0,0,1,2.644,2.732",
    transform: "translate(-41.172 -153.606)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M45.485,70.6a2.644,2.644,0,0,1,2.693,2.674,2.681,2.681,0,0,1-5.361.027,2.644,2.644,0,0,1,2.668-2.7",
    transform: "translate(-32.509 -53.602)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M179.387,148.957a2.684,2.684,0,1,1-2.716-2.634,2.648,2.648,0,0,1,2.716,2.634",
    transform: "translate(-132.125 -111.096)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M189.5,111.1a2.65,2.65,0,0,1-2.681,2.69,2.671,2.671,0,0,1-.027-5.343A2.627,2.627,0,0,1,189.5,111.1",
    transform: "translate(-139.814 -82.339)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M45.484,151.626a2.668,2.668,0,0,1,0-5.335,2.668,2.668,0,1,1,0,5.335",
    transform: "translate(-32.52 -111.072)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M222.271,111.109a2.672,2.672,0,1,1-2.671-2.7,2.671,2.671,0,0,1,2.671,2.7",
    transform: "translate(-164.702 -82.307)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M35.419,113.767a2.668,2.668,0,0,1-.083-5.335,2.668,2.668,0,1,1,.083,5.335",
    transform: "translate(-24.859 -82.327)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M202.4,165.3a2.676,2.676,0,0,1,5.351.043,2.717,2.717,0,0,1-2.7,2.69A2.675,2.675,0,0,1,202.4,165.3",
    transform: "translate(-153.676 -123.513)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M205.065,59.476a2.633,2.633,0,0,1-2.648-2.716,2.672,2.672,0,1,1,2.648,2.716",
    transform: "translate(-153.685 -41.089)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M146.347,45.491a2.67,2.67,0,1,1,2.7,2.657,2.662,2.662,0,0,1-2.7-2.657",
    transform: "translate(-111.114 -32.48)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M165.4,19.8a2.68,2.68,0,1,1,.041-5.359A2.68,2.68,0,0,1,165.4,19.8",
    transform: "translate(-123.555 -10.967)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M111.123,216.908a2.665,2.665,0,1,1-2.66,2.7,2.624,2.624,0,0,1,2.66-2.7",
    transform: "translate(-82.351 -164.688)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M19.824,165.34a2.651,2.651,0,0,1-2.679,2.691,2.694,2.694,0,0,1-2.675-2.712,2.659,2.659,0,0,1,2.642-2.624,2.619,2.619,0,0,1,2.711,2.645",
    transform: "translate(-10.986 -123.526)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M17.184,54.251a2.663,2.663,0,0,1,.044,5.326,2.663,2.663,0,1,1-.044-5.326",
    transform: "translate(-11.008 -41.19)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M113.79,186.83a2.674,2.674,0,1,1-5.346-.149,2.674,2.674,0,0,1,5.346.149",
    transform: "translate(-82.335 -139.768)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M59.561,17.1a2.674,2.674,0,0,1-5.348.029,2.675,2.675,0,1,1,5.348-.029",
    transform: "translate(-41.16 -10.93)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M2.7,113.77a2.674,2.674,0,1,1,0-5.347,2.674,2.674,0,0,1,0,5.347",
    transform: "translate(0 -82.32)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M111.123,38.037a2.667,2.667,0,1,1,2.691-2.677,2.64,2.64,0,0,1-2.691,2.677",
    transform: "translate(-82.358 -24.83)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M111.126,0A2.634,2.634,0,0,1,113.8,2.685a2.669,2.669,0,1,1-5.337-.1A2.64,2.64,0,0,1,111.126,0",
    transform: "translate(-82.35 0)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M72.5,115.577a1.866,1.866,0,0,1-1.876-1.865,1.9,1.9,0,0,1,1.844-1.8,1.835,1.835,0,0,1,.032,3.669",
    transform: "translate(-53.624 -84.966)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M156.969,113.782a1.9,1.9,0,0,1-1.856,1.792,1.835,1.835,0,1,1,1.856-1.792",
    transform: "translate(-116.403 -84.964)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M70.616,137.488a1.927,1.927,0,0,1,1.905-1.743,1.833,1.833,0,1,1-.179,3.661,1.892,1.892,0,0,1-1.726-1.918",
    transform: "translate(-53.614 -103.063)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M155.165,88.09a1.874,1.874,0,0,1,1.807,1.93,1.93,1.93,0,0,1-1.915,1.731,1.832,1.832,0,0,1,.108-3.661",
    transform: "translate(-116.406 -66.882)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M155.143,135.727a1.835,1.835,0,0,1,.043,3.669,1.835,1.835,0,1,1-.043-3.669",
    transform: "translate(-116.409 -103.051)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M74.279,89.913a1.855,1.855,0,0,1-1.792,1.84,1.835,1.835,0,1,1-.013-3.67,1.847,1.847,0,0,1,1.805,1.83",
    transform: "translate(-53.622 -66.877)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M136.313,101.943a1.854,1.854,0,0,1-1.787,1.76,1.8,1.8,0,0,1-1.846-1.877,1.766,1.766,0,0,1,1.77-1.754,1.824,1.824,0,0,1,1.862,1.871",
    transform: "translate(-100.737 -75.98)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M134.456,151.339a1.815,1.815,0,0,1,.009-3.629,1.84,1.84,0,0,1,1.845,1.877,1.81,1.81,0,0,1-1.855,1.751",
    transform: "translate(-100.735 -112.149)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M93.142,100.084a1.8,1.8,0,0,1,1.842,1.788,1.771,1.771,0,0,1-1.775,1.842,1.816,1.816,0,1,1-.067-3.63",
    transform: "translate(-69.357 -75.989)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M113.779,111.91a1.834,1.834,0,1,1-1.822,1.818,1.888,1.888,0,0,1,1.822-1.818",
    transform: "translate(-85.004 -84.968)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M93.222,127.531a1.825,1.825,0,0,1-1.87-1.864A1.854,1.854,0,0,1,93.13,123.9a1.8,1.8,0,0,1,1.855,1.777,1.772,1.772,0,0,1-1.763,1.854",
    transform: "translate(-69.359 -94.071)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M136.314,125.741a1.833,1.833,0,0,1-1.767,1.777,1.8,1.8,0,0,1-1.867-1.856,1.772,1.772,0,0,1,1.749-1.776,1.84,1.84,0,0,1,1.884,1.855",
    transform: "translate(-100.737 -94.061)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M115.619,89.966a1.831,1.831,0,1,1-1.75-1.886,1.89,1.89,0,0,1,1.75,1.886",
    transform: "translate(-85.004 -66.874)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M113.789,163.222a1.834,1.834,0,1,1,1.827-1.811,1.884,1.884,0,0,1-1.827,1.811",
    transform: "translate(-85.001 -121.143)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M115.619,137.544a1.831,1.831,0,1,1-1.837-1.806,1.894,1.894,0,0,1,1.837,1.806",
    transform: "translate(-85.004 -103.059)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M115.619,66.139a1.831,1.831,0,1,1-1.763-1.875,1.888,1.888,0,0,1,1.763,1.875",
    transform: "translate(-85.003 -48.792)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M93.247,76.281a1.812,1.812,0,0,1-.1,3.622,1.84,1.84,0,0,1-1.8-1.923,1.809,1.809,0,0,1,1.9-1.7",
    transform: "translate(-69.352 -57.914)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M93.221,147.739a1.814,1.814,0,0,1,1.763,1.864,1.754,1.754,0,0,1-1.847,1.759,1.815,1.815,0,0,1-1.786-1.85,1.858,1.858,0,0,1,1.87-1.773",
    transform: "translate(-69.358 -112.171)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M134.448,79.883a1.814,1.814,0,0,1-1.768-1.859,1.753,1.753,0,0,1,1.842-1.764,1.814,1.814,0,0,1,1.791,1.846,1.856,1.856,0,0,1-1.866,1.777",
    transform: "translate(-100.738 -57.9)",
    fill: "#9fd983"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.811650e75e94148bf591f2318d39f31f.svg";
export { ForwardRef as ReactComponent };